module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/trip/trip-edit/trip-edit.component.css
// module id = ./src/app/components/trip/trip-edit/trip-edit.component.css
// module chunks = main